import { Timeout } from '../common/const';
import { findAncestorByAttr, findAncestorByClassname, num2str, testRegexInput } from '../common/utils';

/**
 * @cart
 * @multiplier
 */
export const initCart = () => {
    let carts = document.querySelectorAll(`[data-cart-block]`);
    if (!carts.length) return;

    let items = document.querySelectorAll(`[data-product-id]`);
    const btnSubmit = document.querySelector(`.js-order-btn`);
    const totalCart = document.querySelector(`[data-cart-total]`);

    function getCorrectNumber(number) {
        let string = number
            .toLocaleString('de-DE')
            .replace('.', ` `);
        string += ` ₽`;
        return string;
    }

    // set discount cost
    function setCurrentDiscount(block, value) {
        let discountBlock = block.querySelector(`[data-old-cost]`);
        if (!discountBlock) return false;

        let discountVal = discountBlock.getAttribute(`data-old-cost`);
        discountVal = parseInt(discountVal, 10);
        let discount = discountVal * value;

        discountBlock.innerHTML = getCorrectNumber(discount);
        block.classList.add(`discount`);
    }

    // set current cost
    function setCurrentCost(handler, value) {
        let costBlock = handler.querySelector(`[data-cost-block]`);
        let cost = costBlock.querySelector(`[data-cost]`);
        let costVal = cost.getAttribute(`data-cost`);
        costVal = parseInt(costVal, 10);
        cost.setAttribute(`data-new-cost`, costVal * value);
        const number = costVal * value;
        cost.innerHTML = getCorrectNumber(number);

        setCurrentDiscount(costBlock, value);
    }

    // get total cost
    function getTotalCost() {
        let totalCostVal = 0, totalCostDiscountVal = 0, totalWeight = 0;

        for (let cart of carts) {
            let allCosts = cart.querySelectorAll(`[data-new-cost]`);


            allCosts.forEach((allCost) => {
                const product = findAncestorByAttr(allCost, `data-product-id`);
                let allCostsDiscount = product.querySelector(`[data-old-cost]`);
                totalCostVal += parseInt(allCost.getAttribute(`data-new-cost`), 10);

                if (allCostsDiscount) {
                    let value = product.querySelector(`[data-multiplier-input]`).value;
                    totalCostDiscountVal += parseInt(allCostsDiscount.getAttribute(`data-old-cost`), 10) * value;
                } else {
                    totalCostDiscountVal += parseInt(allCost.getAttribute(`data-new-cost`), 10);
                }
            });
        }

        return { totalCostVal, totalCostDiscountVal, totalWeight };
    }

    // set total cost
    function setTotalCost() {
        let totalCostBlock = document.querySelector(`[data-cart-total]`);
        if (!totalCostBlock) return false;
        let cost = totalCostBlock.querySelector(`[data-cost]`);
        let totalCost = document.querySelectorAll(`[data-total]`);
        let totalDiscount = totalCostBlock.querySelector(`[data-discount]`);

        let { totalCostVal, totalCostDiscountVal } = getTotalCost();

        cost.innerHTML = getCorrectNumber(totalCostDiscountVal);
        if (totalDiscount) {
            const number = (totalCostVal - totalCostDiscountVal);
            console.log({totalCostVal, totalCostDiscountVal})
            totalDiscount.innerHTML = getCorrectNumber(number);
        }

        for (let item of totalCost) {
            item.innerHTML = getCorrectNumber(totalCostVal);
        }
    }

    // get total amount of items
    function getTotalAmount() {
        if (!carts.length) return false;
        let totalAmount = 0

        for (let cart of carts) {
            let inputs = cart.querySelectorAll(`[data-multiplier-input]`);

            inputs.forEach((input) => {
                totalAmount += parseInt(input.value, 10);
            });
        }

        return totalAmount;
    }

    // set total item amount
    function setTotalItemAmount() {
        const totalItemBlocks = document.querySelectorAll(`[data-total-amount]`);
        const productsCountBlocks = document.querySelectorAll(`[data-products-count]`);
        const textArr = [` товаров`, ` товара`, ` товар`];
        const total = getTotalAmount() || 0;

        totalItemBlocks.forEach((block) => {
            const content = `${total} ${num2str(total, textArr)}`;
            block.textContent = content;
        });

        productsCountBlocks.forEach((block) => {
            block.textContent = total.toString();
        });
    }

    // Изменить все
    function changeAll(item, value) {
        setCurrentCost(item, value);
        setTotalCost();
        setTotalItemAmount();
    }

    // скрыть блок со скидкой в итоговой таблице
    function hideDiscountBlock() {
        for (let cart of carts) {
            let discount = cart.querySelectorAll(`[data-old-cost]`);
            if (!discount.length) {
                totalCart.querySelector(`[data-discount]`).parentNode.style.display = `none`;
            }
        }
    }

    /**
     * @multiplier
     */
    window.addEventListener(`click`, (e) => {
        const target = e.target;

        // клик по хендлерам + и -
        if (target === target.closest(`[data-multiplier]`)) {
            const input = target.nextElementSibling || target.previousElementSibling;
            const value = input.value;
            const item = findAncestorByAttr(input, `data-product-id`);
            const btnDelete = item.querySelector(`[data-cart-delete]`);

            if (value <= 0) btnDelete.click();
            if (item) changeAll(item, value);
        } else if (target === target.closest(`[data-cart-delete]`)) {
            // click on btn delete
            const attr = findAncestorByAttr(target, `data-product-id`).getAttribute(`data-product-id`);
            items = document.querySelectorAll(`[data-product-id]`);

            items.forEach((item) => {
                if (item.getAttribute(`data-product-id`) === attr) {
                    let cart = findAncestorByAttr(item, `data-cart-block`);
                    let cartDisabled = findAncestorByAttr(item, `data-product-id`);
                    item.remove();

                    // нет доступных для заказа товаров
                    if (cart && cart.querySelectorAll(`[data-product-id]`).length === 0) {
                        cart.remove();
                    }

                    // нет недоступных для заказа товаров
                    if (cartDisabled && cartDisabled.querySelectorAll(`[data-product-id]`).length === 0) {
                        cartDisabled.remove();
                    }

                    // недоступна кнопка заказа
                    carts = document.querySelectorAll(`[data-cart-block]`);
                    if (!carts.length && btnSubmit) btnSubmit.classList.add(`disabled`);
                }

                let handler = item.querySelector(`[data-multiplier]`);
                if (handler) {
                    let input = handler.nextElementSibling || handler.previousElementSibling;
                    changeAll(item, input.value);
                }
            });

            hideDiscountBlock();

            // перезагрузка, если товаров нет
            items = document.querySelectorAll(`[data-product-id]`);
            if (items.length === 0) {
                setTimeout(() => {
                    location.reload();
                }, Timeout.LONG_TIMEOUT);
            }
        }
    });

    // При загрузке страницы
    [].forEach.call(items, (item) => {
        let input = item.querySelector(`[data-multiplier-input]`);
        if (input) {
            const value = input.value;
            changeAll(item, value);

            input.addEventListener(`keypress`, (e) => {
                const regex = /[0-9]|\./;
                testRegexInput(e, regex);
            });

            input.addEventListener(`change`, (e) => {
                changeAll(item, e.target.value);
            });
        }
    });

    hideDiscountBlock();
};
